! function(t, e) {
	"object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("GoCart", [], e) : "object" == typeof exports ? exports.GoCart = e() : t.GoCart = e()
}(window, function() {
	return function(t) {
		var e = {};

		function r(a) {
			if (e[a]) return e[a].exports;
			var n = e[a] = {
				i: a,
				l: !1,
				exports: {}
			};
			return t[a].call(n.exports, n, n.exports, r), n.l = !0, n.exports
		}
		return r.m = t, r.c = e, r.d = function(t, e, a) {
			r.o(t, e) || Object.defineProperty(t, e, {
				enumerable: !0,
				get: a
			})
		}, r.r = function(t) {
			"undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
				value: "Module"
			}), Object.defineProperty(t, "__esModule", {
				value: !0
			})
		}, r.t = function(t, e) {
			if (1 & e && (t = r(t)), 8 & e) return t;
			if (4 & e && "object" == typeof t && t && t.__esModule) return t;
			var a = Object.create(null);
			if (r.r(a), Object.defineProperty(a, "default", {
					enumerable: !0,
					value: t
				}), 2 & e && "string" != typeof t)
				for (var n in t) r.d(a, n, function(e) {
					return t[e]
				}.bind(null, n));
			return a
		}, r.n = function(t) {
			var e = t && t.__esModule ? function() {
				return t.default
			} : function() {
				return t
			};
			return r.d(e, "a", e), e
		}, r.o = function(t, e) {
			return Object.prototype.hasOwnProperty.call(t, e)
		}, r.p = "", r(r.s = 1)
	}([function(t, e, r) {
		var a = r(3),
			n = /^(?:submit|button|image|reset|file)$/i,
			o = /^(?:input|select|textarea|keygen)/i,
			i = /(\[[^\[\]]*\])/g;

		function s(t, e, r) {
			if (e.match(i)) ! function t(e, r, a) {
				if (0 === r.length) return a;
				var n = r.shift(),
					o = n.match(/^\[(.+?)\]$/);
				if ("[]" === n) return e = e || [], Array.isArray(e) ? e.push(t(null, r, a)) : (e._values = e._values || [], e._values.push(t(null, r, a))), e;
				if (o) {
					var i = o[1],
						s = +i;
					isNaN(s) ? (e = e || {})[i] = t(e[i], r, a) : (e = e || [])[s] = t(e[s], r, a)
				} else e[n] = t(e[n], r, a);
				return e
			}(t, function(t) {
				var e = [],
					r = new RegExp(i),
					a = /^([^\[\]]*)/.exec(t);
				for (a[1] && e.push(a[1]); null !== (a = r.exec(t));) e.push(a[1]);
				return e
			}(e), r);
			else {
				var a = t[e];
				a ? (Array.isArray(a) || (t[e] = [a]), t[e].push(r)) : t[e] = r
			}
			return t
		}

		function c(t, e, r) {
			return r = r.replace(/(\r)?\n/g, "\r\n"), r = (r = encodeURIComponent(r)).replace(/%20/g, "+"), t + (t ? "&" : "") + encodeURIComponent(e) + "=" + r
		}
		t.exports = function(t, e) {
			"object" != a(e) ? e = {
				hash: !!e
			} : void 0 === e.hash && (e.hash = !0);
			for (var r = e.hash ? {} : "", i = e.serializer || (e.hash ? s : c), l = t && t.elements ? t.elements : [], u = Object.create(null), d = 0; d < l.length; ++d) {
				var h = l[d];
				if ((e.disabled || !h.disabled) && h.name && o.test(h.nodeName) && !n.test(h.type)) {
					var f = h.name,
						y = h.value;
					if ("checkbox" !== h.type && "radio" !== h.type || h.checked || (y = void 0), e.empty) {
						if ("checkbox" !== h.type || h.checked || (y = ""), "radio" === h.type && (u[h.name] || h.checked ? h.checked && (u[h.name] = !0) : u[h.name] = !1), null == y && "radio" == h.type) continue
					} else if (!y) continue;
					if ("select-multiple" !== h.type) r = i(r, f, y);
					else {
						y = [];
						for (var p = h.options, m = !1, v = 0; v < p.length; ++v) {
							var b = p[v],
								g = e.empty && !b.value,
								C = b.value || g;
							b.selected && C && (m = !0, r = e.hash && "[]" !== f.slice(f.length - 2) ? i(r, f + "[]", b.value) : i(r, f, b.value))
						}!m && e.empty && (r = i(r, f, ""))
					}
				}
			}
			if (e.empty)
				for (var f in u) u[f] || (r = i(r, f, ""));
			return r
		}
	}, function(t, e, r) {
		t.exports = r(4)
	}, function(t, e, r) {}, function(t, e) {
		function r(t) {
			return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
				return typeof t
			} : function(t) {
				return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
			})(t)
		}

		function a(e) {
			return "function" == typeof Symbol && "symbol" === r(Symbol.iterator) ? t.exports = a = function(t) {
				return r(t)
			} : t.exports = a = function(t) {
				return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : r(t)
			}, a(e)
		}
		t.exports = a
	}, function(t, e, r) {
		"use strict";
		r.r(e), r(2);
		var a = "${{amount_no_decimals}}";

		function n(t, e) {
			"string" == typeof t && (t = t.replace(".", ""));
			var r = "",
				n = /\{\{\s*(\w+)\s*\}\}/,
				o = e || a;

			function i(t) {
				var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2,
					r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ",",
					a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : ".";
				if (isNaN(t) || null == t) return 0;
				var n = (t = (t / 100).toFixed(e)).split(".");
				return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1".concat(r)) + (n[1] ? a + n[1] : "")
			}
			switch (o.match(n)[1]) {
				case "amount":
					r = i(t, 2);
					break;
				case "amount_no_decimals":
					r = i(t, 0);
					break;
				case "amount_with_comma_separator":
					r = i(t, 2, ".", ",");
					break;
				case "amount_no_decimals_with_comma_separator":
					r = i(t, 0, ".", ",")
			}
			return o.replace(n, r)
		}

		function o(t) {
			return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
				return typeof t
			} : function(t) {
				return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
			})(t)
		}
		var i = "undefined" != typeof globalThis && globalThis || "undefined" != typeof self && self || void 0 !== i && i,
			s = {
				searchParams: "URLSearchParams" in i,
				iterable: "Symbol" in i && "iterator" in Symbol,
				blob: "FileReader" in i && "Blob" in i && function() {
					try {
						return new Blob, !0
					} catch (t) {
						return !1
					}
				}(),
				formData: "FormData" in i,
				arrayBuffer: "ArrayBuffer" in i
			};
		if (s.arrayBuffer) var c = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
			l = ArrayBuffer.isView || function(t) {
				return t && c.indexOf(Object.prototype.toString.call(t)) > -1
			};

		function u(t) {
			if ("string" != typeof t && (t = String(t)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(t) || "" === t) throw new TypeError("Invalid character in header field name");
			return t.toLowerCase()
		}

		function d(t) {
			return "string" != typeof t && (t = String(t)), t
		}

		function h(t) {
			var e = {
				next: function() {
					var e = t.shift();
					return {
						done: void 0 === e,
						value: e
					}
				}
			};
			return s.iterable && (e[Symbol.iterator] = function() {
				return e
			}), e
		}

		function f(t) {
			this.map = {}, t instanceof f ? t.forEach(function(t, e) {
				this.append(e, t)
			}, this) : Array.isArray(t) ? t.forEach(function(t) {
				this.append(t[0], t[1])
			}, this) : t && Object.getOwnPropertyNames(t).forEach(function(e) {
				this.append(e, t[e])
			}, this)
		}

		function y(t) {
			if (t.bodyUsed) return Promise.reject(new TypeError("Already read"));
			t.bodyUsed = !0
		}

		function p(t) {
			return new Promise(function(e, r) {
				t.onload = function() {
					e(t.result)
				}, t.onerror = function() {
					r(t.error)
				}
			})
		}

		function m(t) {
			var e = new FileReader,
				r = p(e);
			return e.readAsArrayBuffer(t), r
		}

		function v(t) {
			if (t.slice) return t.slice(0);
			var e = new Uint8Array(t.byteLength);
			return e.set(new Uint8Array(t)), e.buffer
		}

		function b() {
			return this.bodyUsed = !1, this._initBody = function(t) {
				var e;
				this.bodyUsed = this.bodyUsed, this._bodyInit = t, t ? "string" == typeof t ? this._bodyText = t : s.blob && Blob.prototype.isPrototypeOf(t) ? this._bodyBlob = t : s.formData && FormData.prototype.isPrototypeOf(t) ? this._bodyFormData = t : s.searchParams && URLSearchParams.prototype.isPrototypeOf(t) ? this._bodyText = t.toString() : s.arrayBuffer && s.blob && (e = t) && DataView.prototype.isPrototypeOf(e) ? (this._bodyArrayBuffer = v(t.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : s.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(t) || l(t)) ? this._bodyArrayBuffer = v(t) : this._bodyText = t = Object.prototype.toString.call(t) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof t ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : s.searchParams && URLSearchParams.prototype.isPrototypeOf(t) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"))
			}, s.blob && (this.blob = function() {
				var t = y(this);
				if (t) return t;
				if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
				if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
				if (this._bodyFormData) throw new Error("could not read FormData body as blob");
				return Promise.resolve(new Blob([this._bodyText]))
			}, this.arrayBuffer = function() {
				return this._bodyArrayBuffer ? y(this) || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength)) : Promise.resolve(this._bodyArrayBuffer)) : this.blob().then(m)
			}), this.text = function() {
				var t = y(this);
				if (t) return t;
				if (this._bodyBlob) return function(t) {
					var e = new FileReader,
						r = p(e);
					return e.readAsText(t), r
				}(this._bodyBlob);
				if (this._bodyArrayBuffer) return Promise.resolve(function(t) {
					for (var e = new Uint8Array(t), r = new Array(e.length), a = 0; a < e.length; a++) r[a] = String.fromCharCode(e[a]);
					return r.join("")
				}(this._bodyArrayBuffer));
				if (this._bodyFormData) throw new Error("could not read FormData body as text");
				return Promise.resolve(this._bodyText)
			}, s.formData && (this.formData = function() {
				return this.text().then(w)
			}), this.json = function() {
				return this.text().then(JSON.parse)
			}, this
		}
		f.prototype.append = function(t, e) {
			t = u(t), e = d(e);
			var r = this.map[t];
			this.map[t] = r ? r + ", " + e : e
		}, f.prototype.delete = function(t) {
			delete this.map[u(t)]
		}, f.prototype.get = function(t) {
			return t = u(t), this.has(t) ? this.map[t] : null
		}, f.prototype.has = function(t) {
			return this.map.hasOwnProperty(u(t))
		}, f.prototype.set = function(t, e) {
			this.map[u(t)] = d(e)
		}, f.prototype.forEach = function(t, e) {
			for (var r in this.map) this.map.hasOwnProperty(r) && t.call(e, this.map[r], r, this)
		}, f.prototype.keys = function() {
			var t = [];
			return this.forEach(function(e, r) {
				t.push(r)
			}), h(t)
		}, f.prototype.values = function() {
			var t = [];
			return this.forEach(function(e) {
				t.push(e)
			}), h(t)
		}, f.prototype.entries = function() {
			var t = [];
			return this.forEach(function(e, r) {
				t.push([r, e])
			}), h(t)
		}, s.iterable && (f.prototype[Symbol.iterator] = f.prototype.entries);
		var g = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];

		function C(t, e) {
			if (!(this instanceof C)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
			var r = (e = e || {}).body;
			if (t instanceof C) {
				if (t.bodyUsed) throw new TypeError("Already read");
				this.url = t.url, this.credentials = t.credentials, e.headers || (this.headers = new f(t.headers)), this.method = t.method, this.mode = t.mode, this.signal = t.signal, r || null == t._bodyInit || (r = t._bodyInit, t.bodyUsed = !0)
			} else this.url = String(t);
			if (this.credentials = e.credentials || this.credentials || "same-origin", !e.headers && this.headers || (this.headers = new f(e.headers)), this.method = function(t) {
					var e = t.toUpperCase();
					return g.indexOf(e) > -1 ? e : t
				}(e.method || this.method || "GET"), this.mode = e.mode || this.mode || null, this.signal = e.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && r) throw new TypeError("Body not allowed for GET or HEAD requests");
			if (this._initBody(r), !("GET" !== this.method && "HEAD" !== this.method || "no-store" !== e.cache && "no-cache" !== e.cache)) {
				var a = /([?&])_=[^&]*/;
				a.test(this.url) ? this.url = this.url.replace(a, "$1_=" + (new Date).getTime()) : this.url += (/\?/.test(this.url) ? "&" : "?") + "_=" + (new Date).getTime()
			}
		}

		function w(t) {
			var e = new FormData;
			return t.trim().split("&").forEach(function(t) {
				if (t) {
					var r = t.split("="),
						a = r.shift().replace(/\+/g, " "),
						n = r.join("=").replace(/\+/g, " ");
					e.append(decodeURIComponent(a), decodeURIComponent(n))
				}
			}), e
		}

		function _(t) {
			var e = new f;
			return t.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function(t) {
				var r = t.split(":"),
					a = r.shift().trim();
				if (a) {
					var n = r.join(":").trim();
					e.append(a, n)
				}
			}), e
		}

		function M(t, e) {
			if (!(this instanceof M)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
			e || (e = {}), this.type = "default", this.status = void 0 === e.status ? 200 : e.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in e ? e.statusText : "", this.headers = new f(e.headers), this.url = e.url || "", this._initBody(t)
		}
		C.prototype.clone = function() {
			return new C(this, {
				body: this._bodyInit
			})
		}, b.call(C.prototype), b.call(M.prototype), M.prototype.clone = function() {
			return new M(this._bodyInit, {
				status: this.status,
				statusText: this.statusText,
				headers: new f(this.headers),
				url: this.url
			})
		}, M.error = function() {
			var t = new M(null, {
				status: 0,
				statusText: ""
			});
			return t.type = "error", t
		};
		var T = [301, 302, 303, 307, 308];
		M.redirect = function(t, e) {
			if (-1 === T.indexOf(e)) throw new RangeError("Invalid status code");
			return new M(null, {
				status: e,
				headers: {
					location: t
				}
			})
		};
		var S = i.DOMException;
		try {
			new S
		} catch (t) {
			(S = function(t, e) {
				this.message = t, this.name = e;
				var r = Error(t);
				this.stack = r.stack
			}).prototype = Object.create(Error.prototype), S.prototype.constructor = S
		}

		function D(t, e) {
			return new Promise(function(r, a) {
				var n = new C(t, e);
				if (n.signal && n.signal.aborted) return a(new S("Aborted", "AbortError"));
				var c = new XMLHttpRequest;

				function l() {
					c.abort()
				}
				c.onload = function() {
					var t = {
						status: c.status,
						statusText: c.statusText,
						headers: _(c.getAllResponseHeaders() || "")
					};
					t.url = "responseURL" in c ? c.responseURL : t.headers.get("X-Request-URL");
					var e = "response" in c ? c.response : c.responseText;
					setTimeout(function() {
						r(new M(e, t))
					}, 0)
				}, c.onerror = function() {
					setTimeout(function() {
						a(new TypeError("Network request failed"))
					}, 0)
				}, c.ontimeout = function() {
					setTimeout(function() {
						a(new TypeError("Network request failed"))
					}, 0)
				}, c.onabort = function() {
					setTimeout(function() {
						a(new S("Aborted", "AbortError"))
					}, 0)
				}, c.open(n.method, function(t) {
					try {
						return "" === t && i.location.href ? i.location.href : t
					} catch (e) {
						return t
					}
				}(n.url), !0), "include" === n.credentials ? c.withCredentials = !0 : "omit" === n.credentials && (c.withCredentials = !1), "responseType" in c && (s.blob ? c.responseType = "blob" : s.arrayBuffer && n.headers.get("Content-Type") && -1 !== n.headers.get("Content-Type").indexOf("application/octet-stream") && (c.responseType = "arraybuffer")), !e || "object" !== o(e.headers) || e.headers instanceof f ? n.headers.forEach(function(t, e) {
					c.setRequestHeader(e, t)
				}) : Object.getOwnPropertyNames(e.headers).forEach(function(t) {
					c.setRequestHeader(t, d(e.headers[t]))
				}), n.signal && (n.signal.addEventListener("abort", l), c.onreadystatechange = function() {
					4 === c.readyState && n.signal.removeEventListener("abort", l)
				}), c.send(void 0 === n._bodyInit ? null : n._bodyInit)
			})
		}
		D.polyfill = !0, i.fetch || (i.fetch = D, i.Headers = f, i.Request = C, i.Response = M);
		var E = r(0),
			j = r.n(E);

		function A(t, e) {
			for (var r = 0; r < e.length; r++) {
				var a = e[r];
				a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a)
			}
		}
		var N = function() {
			function t(e) {
				! function(e, r) {
					if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
				}(this), this.defaults = Object.assign({}, {
					cartModalFail: ".js-go-cart-modal-fail",
					cartModalFailClose: ".js-go-cart-modal-fail-close",
					cartModal: ".js-go-cart-modal",
					cartModalClose: ".js-go-cart-modal-close",
					cartModalContent: ".js-go-cart-modal-content",
					cartDrawer: ".js-go-cart-drawer",
					cartDrawerContent: ".js-go-cart-drawer-content",
					cartDrawerSubTotal: ".js-go-cart-drawer-subtotal",
					cartDrawerUpsell: ".js-go-cart-drawer-upsell",
					cartDrawerFooter: ".js-go-cart-drawer-footer",
					cartDrawerClose: ".js-go-cart-drawer-close",
					cartMiniCart: ".js-go-cart-mini-cart",
					cartMiniCartContent: ".js-go-cart-mini-cart-content",
					cartMiniCartSubTotal: ".js-go-cart-mini-cart-subtotal",
					cartMiniCartUpsell: ".js-go-cart-mini-cart-upsell",
					cartMiniCartFooter: ".js-go-cart-mini-cart-footer",
					cartTrigger: ".js-go-cart-trigger, js-go-cart-abrir",
					cartOverlay: ".js-go-cart-overlay",
					cartCount: ".js-go-cart-counter",
					addToCart: ".js-go-cart-add-to-cart",
					removeFromCart: ".js-go-cart-remove-from-cart",
					removeFromCartNoDot: "js-go-cart-remove-from-cart",
					itemQuantity: ".js-go-cart-quantity",
					itemQuantityPlus: ".js-go-cart-quantity-plus",
					itemQuantityMinus: ".js-go-cart-quantity-minus",
					cartMode: "drawer",
					drawerDirection: "right",
					displayModal: !1,
					moneyFormat: "${{amount}}",
					labelAddedToCart: "was added to your cart.",
					labelCartIsEmpty: "Your Cart Is Empty",
					labelQuantity: "Cantidad:",
					labelRemove: ""
				}, e), this.cartModalFail = document.querySelector(this.defaults.cartModalFail), this.cartModalFailClose = document.querySelector(this.defaults.cartModalFailClose), this.cartModal = document.querySelector(this.defaults.cartModal), this.cartModalClose = document.querySelectorAll(this.defaults.cartModalClose), this.cartModalContent = document.querySelector(this.defaults.cartModalContent), this.cartDrawer = document.querySelector(this.defaults.cartDrawer), this.cartDrawerContent = document.querySelector(this.defaults.cartDrawerContent), this.cartDrawerSubTotal = document.querySelector(this.defaults.cartDrawerSubTotal), this.cartDrawerUpsell = document.querySelector(this.defaults.cartDrawerUpsell), this.cartDrawerFooter = document.querySelector(this.defaults.cartDrawerFooter), this.cartDrawerClose = document.querySelector(this.defaults.cartDrawerClose), this.cartMiniCart = document.querySelector(this.defaults.cartMiniCart), this.cartMiniCartContent = document.querySelector(this.defaults.cartMiniCartContent), this.cartMiniCartSubTotal = document.querySelector(this.defaults.cartMiniCartSubTotal), this.cartMiniCartUpsell = document.querySelector(this.defaults.cartMiniCartUpsell), this.cartMiniCartFooter = document.querySelector(this.defaults.cartMiniCartFooter), this.cartTrigger = document.querySelector(this.defaults.cartTrigger), this.cartOverlay = document.querySelector(this.defaults.cartOverlay), this.cartCount = document.querySelector(this.defaults.cartCount), this.addToCart = document.querySelectorAll(this.defaults.addToCart), this.removeFromCart = this.defaults.removeFromCart, this.removeFromCartNoDot = this.defaults.removeFromCartNoDot, this.itemQuantity = this.defaults.itemQuantity, this.itemQuantityPlus = this.defaults.itemQuantityPlus, this.itemQuantityMinus = this.defaults.itemQuantityMinus, this.cartMode = this.defaults.cartMode, this.drawerDirection = this.defaults.drawerDirection, this.displayModal = this.defaults.displayModal, this.moneyFormat = this.defaults.moneyFormat, this.labelAddedToCart = this.defaults.labelAddedToCart, this.labelCartIsEmpty = this.defaults.labelCartIsEmpty, this.labelQuantity = this.defaults.labelQuantity, this.labelRemove = this.defaults.labelRemove, this.init()
			}
			var e, r, a;
			return e = t, a = [{
				key: "removeItemAnimation",
				value: function(t) {
					t.classList.add("is-invisible")
				}
			}], (r = [{
				key: "init",
				value: function() {
					var t = this;
					this.fetchCart(), this.isDrawerMode && this.setDrawerDirection(), document.addEventListener("click", function(e) {
						if (e.target.matches(t.defaults.addToCart)) {
							e.preventDefault();
							for (var r = e.target.parentNode;
								"form" !== r.tagName.toLowerCase();) r = r.parentNode;
							var a = r.getAttribute("id");
							t.addItemToCart(a)
						}
					}, !1), this.cartTrigger.addEventListener("click", function() {
						t.isDrawerMode ? t.openCartDrawer() : t.openMiniCart(), t.openCartOverlay()
					}), this.cartOverlay.addEventListener("click", function() {
						t.closeFailModal(), t.closeCartModal(), t.isDrawerMode ? t.closeCartDrawer() : t.closeMiniCart(), t.closeCartOverlay()
					}), this.isDrawerMode && this.cartDrawerClose.addEventListener("click", function() {
						t.closeCartDrawer(), t.closeCartOverlay()
					}), this.displayModal && this.cartModalClose.forEach(function(e) {
						e.addEventListener("click", function() {
							t.closeFailModal(), t.closeCartModal(), t.isDrawerMode ? t.closeCartDrawer() : t.closeMiniCart(), t.closeCartOverlay()
						})
					}), this.cartModalFailClose.addEventListener("click", function() {
						t.closeFailModal(), t.closeCartModal(), t.isDrawerMode ? t.closeCartDrawer() : t.closeMiniCart(), t.closeCartOverlay()
					})
				}
			}, {
				key: "fetchCart",
				value: function(t) {
					var e = this;
					window.fetch("/cart.js", {
						credentials: "same-origin",
						method: "GET"
					}).then(function(t) {
						return t.json()
					}).then(function(r) {
                        if(r.item_count <= 0){
							try {
								$(".chocolate-bar").removeClass("one-left").removeClass("complete");
								$(".content-ribbon-p").html("<strong>FREE SHIPPING</strong> on orders with 2+ packs");
								$(".announcement-bar__message").html("<strong>FREE SHIPPING</strong> on orders with 2+ packs");
								$(".content-ribbon-h3").text("");

                                document.querySelector(".js-go-cart-drawer-upsell h3").textContent = 'CURB YOUR CRAVINGS WITH...';
                              
							} catch {}
						}else{
                          document.querySelector(".js-go-cart-drawer-upsell h3").textContent = 'COMPLETE YOUR CRAVINGS WITH…';
                        }

						// Upsell cart
							$.getJSON('/collections/upsell/products.json', function(sidecart_upsells){
								let k_upsells = 0; let current_items_in_cart = []; $(".go-cart-item__single").map(function(){
									current_items_in_cart.push($(this).data("handle"));
								});
		
								$('.sidecart__upsells').html('').removeClass("slick-initialized slick-slider");
								for(let x in sidecart_upsells.products){
							
									let upsell = sidecart_upsells.products[x];
		
									if(!current_items_in_cart.includes(upsell.handle)){
										let variant_id = upsell.variants[0].id;
									
										if(upsell.variants[0].available) {
										let upsell_template = `
											<div class="sidecart__upsell">
												<a href="/products/${upsell.handle}">
													<img src="${upsell.images[0].src}"/>
													<span>${upsell.title}</span>
												</a>
												<a class="sidecart__atc ajax-atc" data-variant="${variant_id}" href="javascript:;">ADD</a>
											</div>`;
										$('.sidecart__upsells').append(upsell_template);
										k_upsells++;
										}
									}
								}
		
								if(k_upsells > 0){
									$(".go-cart-drawer__content").removeClass("no-upsells");
									$(".js-go-cart-drawer-upsell").removeClass("hide");
									setTimeout(function(){ 
										$('.sidecart__upsells').slick({
											infinite: true,
											slidesToShow: 3,
											slidesToScroll: 1,
											dots: true,
											arrows: false
										});
									}, 300);
								} else {
									$(".go-cart-drawer__content").addClass("no-upsells");
									$(".js-go-cart-drawer-upsell").addClass("hide");
								}
							
							});
                      	// End Upsell cart

						return e.fetchHandler(r, t)
					}).catch(function(t) {
						throw e.ajaxRequestFail(), new Error(t)
					})
				}
			}, {
				key: "addItemToCart",
				value: function(t) {
					var e = this,
						r = document.querySelector("#".concat(t)),
						a = j()(r, {
							hash: !0
						});
					window.fetch("/cart/add.js", {
						method: "POST",
						credentials: "include",
						headers: {
							"Content-Type": "application/json"
						},
						body: JSON.stringify(a)
					}).then(function(t) {
						return t.json()
					}).then(function(t) {
						rdt('track', 'AddToCart');
						return e.addItemToCartHandler(t)
					}).catch(function(t) {
						throw e.ajaxRequestFail(), new Error(t)
					})
				}
			}, {
				key: "removeItem",
				value: function(t) {
					var e = this;
					window.fetch("/cart/change.js", {
						method: "POST",
						credentials: "same-origin",
						body: JSON.stringify({
							quantity: 0,
							line: t
						}),
						headers: {
							"Content-Type": "application/json"
						}
					}).then(function(t) {
						return t.json()
					}).then(function() {
						return e.fetchCart()
					}).catch(function(t) {
						throw e.ajaxRequestFail(), new Error(t)
					})
					
				}
			}, {
				key: "changeItemQuantity",
				value: function(t, e) {
					var r = this;
					window.fetch("/cart/change.js", {
						method: "POST",
						credentials: "same-origin",
						body: JSON.stringify({
							quantity: e,
							line: t
						}),
						headers: {
							"Content-Type": "application/json"
						}
					}).then(function(t) {
						return t.json()
					}).then(function() {
						return r.fetchCart()
					}).catch(function(t) {
						throw r.ajaxRequestFail(), new Error(t)
					})
				}
			}, {
				key: "cartItemCount",
				value: function(t) {
					this.cartCount.innerHTML = t.item_count
				}
			}, {
				key: "fetchAndOpenCart",
				value: function() {
					var t = this;
					this.fetchCart(function() {
						t.isDrawerMode ? t.openCartDrawer() : t.openMiniCart(), t.openCartOverlay()
					})
				}
			}, {
				key: "fetchAndOpenModal",
				value: function(t) {
					var e = this;
					this.fetchCart(function() {
						e.renderCartModal(t), e.openCartModal(), e.openCartOverlay()
					})
				}
			}, {
				key: "fetchHandler",
				value: function(t, e) {
					this.cartItemCount(t), this.isDrawerMode ? 0 === t.item_count ? (this.renderBlankCartDrawer(), this.cartDrawerFooter.classList.add("is-invisible")) : (this.renderDrawerCart(t), this.cartDrawerFooter.classList.remove("is-invisible"), "function" == typeof e && e(t)) : 0 === t.item_count ? (this.renderBlankMiniCart(), this.cartMiniCartFooter.classList.add("is-invisible")) : (this.renderMiniCart(t), this.cartMiniCartFooter.classList.remove("is-invisible"), "function" == typeof e && e(t))
				}
			}, {
				key: "addItemToCartHandler",
				value: function(t) {
					return this.displayModal ? this.fetchAndOpenModal(t) : this.fetchAndOpenCart()
				}
			}, {
				key: "ajaxRequestFail",
				value: function() {
					this.openFailModal(), this.openCartOverlay()
				}
			}, {
				key: "renderCartModal",
				value: function(t) {
					this.clearCartModal();
					var e = t.variant_title;
					e = null === e ? "" : "(".concat(e, ")");
					var r = '\n        <div class="go-cart-modal-item">\n            <div class="go-cart-item__image" style="background-image: url('.concat(t.image, ');"><br></div>\n            <div class="go-cart-item__info">\n                <a href="').concat(t.url, '" class="go-cart-item__title">').concat(t.product_title, " ").concat(e, "</a> ").concat(this.labelAddedToCart, "\n            </div>\n        </div>\n      ");
					this.cartModalContent.innerHTML += r
				}
			}, {
				key: "renderDrawerCart",
				value: function(e) {
					window.evalue = e;

					jQuery.getJSON("/cart.js", function(t) {
						let e = t.items;
						//1 == t.item_count ? ($(".js-go-cart-drawer-upsell").removeClass("d-none"), $(".content-ribbon-header").removeClass("d-none"), $(".content-ribbon-header img").attr("src", "https://cdn.shopify.com/s/files/1/0540/9013/7773/files/free.png?v=1636118642"), $(".content-ribbon-p").html("You are 1 pack away from <strong>FREE SHIPPING</strong>"), $(".content-ribbon-h3").text(""), $(".announcement-bar__message").html("You are 1 pack away from <strong>FREE SHIPPING</strong>")) : t.item_count > 1 && ($(".js-go-cart-drawer-upsell").removeClass("d-none"), $(".content-ribbon-header").removeClass("d-none"), $(".content-ribbon-header img").attr("src", "https://cdn.shopify.com/s/files/1/0540/9013/7773/files/free-two.png?v=1636118792"), $(".content-ribbon-h3").text("Mission Accomplished!"), $(".content-ribbon-p").html("Your order now qualifies for <strong>FREE SHIPPING</strong>"), $(".announcement-bar__message").html("Your order now qualifies for <b>FREE SHIPPING</b>"));
                      3495 >= t.items_subtotal_price ? ($(".js-go-cart-drawer-upsell").removeClass("d-none"), $(".content-ribbon-header").removeClass("d-none"), $(".content-ribbon-header img").attr("src", "https://cdn.shopify.com/s/files/1/0540/9013/7773/files/free.png?v=1636118642"), $(".content-ribbon-p").html("You are 1 pack away from <strong>FREE SHIPPING</strong>"), $(".chocolate-bar").addClass("one-left").removeClass("complete"), $(".content-ribbon-h3").text(""), $(".announcement-bar__message").html("You are 1 pack away from <strong>FREE SHIPPING</strong>")) : ($(".js-go-cart-drawer-upsell").removeClass("d-none"), $(".content-ribbon-header").removeClass("d-none"), $(".content-ribbon-h3").text("Mission Accomplished!"), $(".chocolate-bar").removeClass("one-left").addClass("complete"), $(".content-ribbon-p").html("Your order now qualifies for <b>FREE SHIPPING</b>"), $(".content-ribbon-header img").attr("src", "https://cdn.shopify.com/s/files/1/0540/9013/7773/files/free-two.png?v=1636118792"), $(".announcement-bar__message").html("Your order now qualifies for <b>FREE SHIPPING</b>"));

						for (var r = 0; r < e.length; r++) "Classic Milk Chocolate Style" == e[r].product_title ? ($(".title-upsell-cart").text("COMPLETE YOUR CRAVINGS WITH 4…"), $(".content-upsel-cart").addClass("almond"), $(".content-upsel-cart p").text("ALMOND DARK CHOCOLATE STYLE"), $(".content-upsel-cart input").val("39884618432685")) : "Almond Dark Chocolate Style" == e[r].product_title && ($(".title-upsell-cart").text("COMPLETE YOUR CRAVINGS WITH 2…"), $(".content-upsel-cart").removeClass("almond"), $(".content-upsel-cart p").text("Classic Milk Chocolate Style"), $(".content-upsel-cart input").val("39884593856685"))

						if (start > actual) {
							var items = t.items;
							var results = items.filter(x => x.id === 41650108760237);
	
							if ((results.length == 0) && (items.length > 0)) {
								jQuery.post('/cart/add.js', {
								quantity: 1,
								id: 41650108760237  
								});
	
								setTimeout(function() {
									goCart.fetchAndOpenCart();
									goCart.fetchCart();
								}, 500);
							}
							if (results.length > 0 ) {
								if ((results.length == 1) && (items.length == 1)) {
									console.log('remove')
								// remove free gift if there are no other products in cart
								jQuery.post('/cart/update.js', {updates: {41650108760237: 0}});
									goCart.fetchAndOpenCart();
									goCart.fetchCart();
								} else {
									console.log('agrego')
								// update free gift gift to quantity = 1, for customers adding multiple free gifts
								jQuery.post('/cart/update.js', {updates: {41650108760237: 1}});
								}
							}
						} 
						else {
							
						}
					});

					var r = this;
					this.clearCartDrawer(), e.items.forEach(function(t, e) {
						var a = t.variant_title;
						null === a && (a = "");
						
						
						try {
							var current_plan = 'Delivery: ' + t.selling_plan_allocation.selling_plan.name;
						} catch (e) {
							var current_plan = 'One time';
						}

						var properties_template = '<div class="line-property--wrapper go-cart-item__lines">';
						for(var x in t.properties){

							if(x.charAt(0) != '_'){
								// No private property
								properties_template += '<div class="line-property">';
								properties_template += '<span>' + x + ':</span> ';
								properties_template += '<span>' + t.properties[x] + '</span>' ;
								properties_template += '</div>'
							};
						}
						properties_template += '</div>';
						var discount_template = '<div class="line-property--wrapper go-cart-item__lines">';
						for(var x in t.discounts){
								discount_template += '<div class="line-property">';
								discount_template += '<span><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-text" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path></svg>' + t.discounts[x]["title"] + '</span> ';
								//discount_template += '<span>' + n(t.discounts[x]["amount"], r.moneyFormat) + '</span>' ;
								discount_template += '</div>'
						}
						discount_template += '</div>';
						var product_price = '';
						if (t.original_price > t.discounted_price){
							product_price ='<s>'+n((t.original_price * t.quantity), r.moneyFormat)+'</s>'+n((t.discounted_price * t.quantity), r.moneyFormat)
						}
						else {
    					  // BUG FIX LR 1-DEC-2022
                          // was using line_price to get total amount, but should be using the original_price
                          // product_price =n((t.line_price * t.quantity), r.moneyFormat)
                          product_price =n((t.original_price * t.quantity), r.moneyFormat)
						}

						var o = '\n        <div class="go-cart-item__single '+t.handle+'" data-handle="'+t.handle+'"  data-line="'.concat(Number(e + 1), '">\n            <div class="go-cart-item__info-wrapper">\n                <div class="go-cart-item__image" style="background-image: url(').concat(t.image, ')"><br></div>\n                <div class="go-cart-item__info">\n                    <a href="').concat(t.url, '" class="go-cart-item__title">').concat(t.product_title, '</a>\n                    <div class="go-cart-item__variant">').concat(a, '</div>\n');



						var is_subscription_class = '';
                        var is_subscription_wrapper = '';

                        if(t.selling_plan_allocation !== undefined){
                            is_subscription_class = 'subscribe-control--active';
                            is_subscription_wrapper = 'go-cart-item__single--subscription';
                        }

						var o = '\n        <div class="go-cart-item__single" data-handle="'+t.handle+'"  data-line="'.concat(Number(e + 1), '">\n            <div class="go-cart-item__info-wrapper">\n                <div class="go-cart-item__image" style="background-image: url(').concat(t.image, ');"><br></div>\n                <div class="go-cart-item__info">\n                    <a href="').concat(t.url, '" class="go-cart-item__title">').concat(t.product_title, '</a>\n                    <div class="go-cart-item__variant">').concat(a, '</div>\n');


						o += properties_template;
						o += discount_template;


						o += '<div class="subscribe-control '+is_subscription_class+'" data-id="'+t.product_id+'" data-variant="'+t.id+'" data-line="'+Number(e + 1)+'">';
						
						if(current_plan != 'One time'){
							o += '<span class="subscribe-control__plan">'+current_plan+'</span>';
						}

                        o += '</div>';

						o += '<div class="go-cart-item__quantity">\n                        <span class="go-cart-item__quantity-label">'.concat(r.labelQuantity, ' </span>\n                        <span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>\n                        <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="').concat(t.quantity, '" disabled>\n                        <span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>\n                    </div>\n                </div>\n            </div>\n            <div class="go-cart-item__price">').concat(product_price, '</div>\n<a class="btn btn-primary small go-cart-item__remove ').concat(r.removeFromCartNoDot, '"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="#868686" viewBox="0 0 20 20"><path d="M15.89 14.696l-4.734-4.734 4.717-4.717c.4-.4.37-1.085-.03-1.485s-1.085-.43-1.485-.03L9.641 8.447 4.97 3.776c-.4-.4-1.085-.37-1.485.03s-.43 1.085-.03 1.485l4.671 4.671-4.688 4.688c-.4.4-.37 1.085.03 1.485s1.085.43 1.485.03l4.688-4.687 4.734 4.734c.4.4 1.085.37 1.485-.03s.43-1.085.03-1.485z"></path></svg>').concat(r.labelRemove, "</a>\n        </div>\n      ");



						r.cartDrawerContent.innerHTML += o
					}), this.cartDrawerSubTotal.innerHTML = e.original_total_price > e.total_price ? '<s>'+n(e.original_total_price, r.moneyFormat)+'</s>'+n(e.total_price, r.moneyFormat) : n(e.total_price, r.moneyFormat), this.cartDrawerSubTotal.parentNode.classList.remove("is-invisible"), document.querySelectorAll(this.removeFromCart).forEach(function(e) {
						e.addEventListener("click", function() {
							t.removeItemAnimation(e.parentNode);
							var a = e.parentNode.getAttribute("data-line");
							r.removeItem(a)
						})
					}), document.querySelectorAll(this.itemQuantityPlus).forEach(function(t) {
						t.addEventListener("click", function() {
							var e = t.parentNode.parentNode.parentNode.parentNode.getAttribute("data-line"),
								a = Number(t.parentNode.querySelector(r.itemQuantity).value) + 1;
							r.changeItemQuantity(e, a)
						})
					}), document.querySelectorAll(this.itemQuantityMinus).forEach(function(e) {
						e.addEventListener("click", function() {
							var a = e.parentNode.parentNode.parentNode.parentNode.getAttribute("data-line"),
								n = Number(e.parentNode.querySelector(r.itemQuantity).value) - 1;
							r.changeItemQuantity(a, n), 0 === Number(e.parentNode.querySelector(r.itemQuantity).value - 1) && t.removeItemAnimation(e.parentNode.parentNode.parentNode.parentNode)
						})
					})

					// Check if subscription in cart
					if(document.getElementsByClassName("subscribe-control__plan").length){
						document.querySelector(".content-subscribe-switch").classList.add("active-subscriptions");
						document.querySelector(".sidecart__switch--input").checked = true;
					} else {
						document.querySelector(".content-subscribe-switch").classList.remove("active-subscriptions");
					}

				}
			}, {
				key: "renderMiniCart",
				value: function(e) {
					var r = this;
					this.clearMiniCart(), e.items.forEach(function(t, e) {
						var a = t.variant_title;
						null === a && (a = "");
						var o = '\n        <div class="go-cart-item__single" data-handle="'+t.handle+'" data-line="'.concat(Number(e + 1), '">\n            <div class="go-cart-item__info-wrapper">\n                <div class="go-cart-item__image" style="background-image: url(').concat(t.image, ');"><br></div>\n                <div class="go-cart-item__info">\n                    <a href="').concat(t.url, '" class="go-cart-item__title">').concat(t.product_title, '</a>\n                    <div class="go-cart-item__variant">').concat(a, '</div>\n                    <div class="go-cart-item__quantity">\n                        <span class="go-cart-item__quantity-label">').concat(r.labelQuantity, ' </span>\n                        <span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>\n                        <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="').concat(t.quantity, '" disabled>\n                        <span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>\n                    </div>\n                </div>\n            </div>\n            <div class="go-cart-item__price">').concat(n(t.line_price, r.moneyFormat), '</div>\n            <a class="btn btn-primary small go-cart-item__remove ').concat(r.removeFromCartNoDot, '">').concat(r.labelRemove, "</a>\n        </div>\n      ");
						r.cartMiniCartContent.innerHTML += o
					}), this.cartMiniCartSubTotal.innerHTML = n(e.total_price, this.moneyFormat), this.cartMiniCartSubTotal.parentNode.classList.remove("is-invisible"), document.querySelectorAll(this.removeFromCart).forEach(function(e) {
						e.addEventListener("click", function() {
							t.removeItemAnimation(e.parentNode);
							var a = e.parentNode.getAttribute("data-line");
							r.removeItem(a)
						})
					}), document.querySelectorAll(this.itemQuantityPlus).forEach(function(t) {
						t.addEventListener("click", function() {
							var e = t.parentNode.parentNode.parentNode.parentNode.getAttribute("data-line"),
								a = Number(t.parentNode.querySelector(r.itemQuantity).value) + 1;
							r.changeItemQuantity(e, a)
						})
					}), document.querySelectorAll(this.itemQuantityMinus).forEach(function(e) {
						e.addEventListener("click", function() {
							var a = e.parentNode.parentNode.parentNode.parentNode.getAttribute("data-line"),
								n = Number(e.parentNode.querySelector(r.itemQuantity).value) - 1;
							r.changeItemQuantity(a, n), 0 === Number(e.parentNode.querySelector(r.itemQuantity).value - 1) && t.removeItemAnimation(e.parentNode.parentNode.parentNode.parentNode)
						})
					})
				}
			}, {
				key: "renderBlankCartDrawer",
				value: function() {
					this.cartDrawerSubTotal.parentNode.classList.add("is-invisible"), this.clearCartDrawer(), this.cartDrawerContent.innerHTML = '<div class="go-cart__empty">'.concat(this.labelCartIsEmpty, "</div>")
				}
			}, {
				key: "renderBlankMiniCart",
				value: function() {
					this.cartMiniCartSubTotal.parentNode.classList.add("is-invisible"), this.clearMiniCart(), this.cartMiniCartContent.innerHTML = '<div class="go-cart__empty">'.concat(this.labelCartIsEmpty, "</div>")
				}
			}, {
				key: "clearCartDrawer",
				value: function() {
					this.cartDrawerContent.innerHTML = ""
				}
			}, {
				key: "clearMiniCart",
				value: function() {
					this.cartMiniCartContent.innerHTML = ""
				}
			}, {
				key: "clearCartModal",
				value: function() {
					this.cartModalContent.innerHTML = ""
				}
			}, {
				key: "openCartDrawer",
				value: function() {
					this.cartDrawer.classList.add("is-open")
				}
			}, {
				key: "closeCartDrawer",
				value: function() {
					this.cartDrawer.classList.remove("is-open")
				}
			}, {
				key: "openMiniCart",
				value: function() {
					this.cartMiniCart.classList.add("is-open")
				}
			}, {
				key: "closeMiniCart",
				value: function() {
					this.cartMiniCart.classList.remove("is-open")
				}
			}, {
				key: "openFailModal",
				value: function() {
					this.cartModalFail.classList.add("is-open")
				}
			}, {
				key: "closeFailModal",
				value: function() {
					this.cartModalFail.classList.remove("is-open")
				}
			}, {
				key: "openCartModal",
				value: function() {
					this.cartModal.classList.add("is-open")
				}
			}, {
				key: "closeCartModal",
				value: function() {
					this.cartModal.classList.remove("is-open")
				}
			}, {
				key: "openCartOverlay",
				value: function() {
					this.cartOverlay.classList.add("is-open")
				}
			}, {
				key: "closeCartOverlay",
				value: function() {
					this.cartOverlay.classList.remove("is-open")
				}
			}, {
				key: "setDrawerDirection",
				value: function() {
					this.cartDrawer.classList.add("go-cart__drawer--".concat(this.drawerDirection))
				}
			}, {
				key: "isDrawerMode",
				get: function() {
					return "drawer" === this.cartMode
				}
			}]) && A(e.prototype, r), a && A(e, a), t
		}();
		e.default = N
	}]).default
});
